import React, { useEffect, useState } from 'react';
import QuestionaireForm from '../../components/CustomerQuestionnaire/QuestionaireForm';
import CapacityForLossQuestionnaire from '../../components/CapacityForLossQuestionnaire/CapacityForLossQuestionnaire';
import Store from 'store/store';
import withMeta from 'hoc/withMeta';
import { compose } from 'ramda';
import api from 'api';
import { QuestionType } from 'store/modules/Quesionnare/types';
import { Loader, RemoteSubmit, Button } from 'components/Base';
import jwt_decode from 'jwt-decode';
import InfoBanner from 'components/Base/InfoBanner/InfoBanner';
import ExperienceQuestionnaire from 'components/ExperienceQuestionnaire/ExperienceQuestionnaire';
const { connect, actions, selectors } = Store;

interface QuestionaireValues {
  [key: string]: string;
}

const QuestionairePage = (props: any) => {
  const [surveyData, setSurveyData] = useState([] as QuestionType[]);
  const [isLoading, setIsloading] = useState(false);
  const [decodedToken, setDecodedToken] = useState({} as any);
  const [validToken, setValidToken] = useState(true);
  const [customerName, setCustomerName] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successful, setSucessful] = useState(false);
  const [hasCfl, setHasCfl] = useState(false);
  const [atrComplete, setAtrComplete] = useState(false);
  const [cflComplete, setCflComplete] = useState(false);
  const [cflSubmitted, setCflSubmitted] = useState(false);
  const [showSubmit, setShowSubmit] = useState(true);
  const [riskProfiler, setRiskProfiler] = useState(null);

  useEffect(() => {
    setIsloading(true);
    setDecodedToken(jwt_decode(props.match.params.token));
  }, [props.match.params.token]);

  useEffect(() => {
    setRiskProfiler(props.riskProfiler);
  }, [props.riskProfiler]);

  const submit = async (values: QuestionaireValues) => {
    // print the form values to the console
    setIsSubmitting(true);
    try {
      const data = {
        responses: Object.values(values).map(value => JSON.parse(value))
      };
      await api.postEmailedQuestionnaireReponses(
        decodedToken.company_schema,
        props.match.params.token,
        data
      );
      setSubmitted(true);
      setIsSubmitting(false);
      setSucessful(true);
    } catch (err) {
      setSubmitted(true);
      setIsSubmitting(false);
      setSucessful(false);
    }
  };

  useEffect(() => {
    const getQuestionnaire = async () => {
      if (decodedToken && decodedToken.company_name) {
        try {
          const response = await api.getEmailedCustomerQuestionnaire(
            props.match.params.token,
            decodedToken.company_schema
          );
          setSurveyData(response.data.questionnaire.questions);
          setCustomerName(response.data.display_name);
          setRiskProfiler(response.data.risk_profiler);
          setHasCfl(decodedToken.include_cfl);
          setIsloading(false);
        } catch (error) {
          setValidToken(false);
          setIsloading(false);
        }
      }
    };
    getQuestionnaire();
  }, [decodedToken, props.match.params.token]);

  return (
    <>
      <Loader isLoading={isLoading}>
        {validToken && !isLoading ? (
          <>
            <div
              style={{
                display:
                  !hasCfl || !atrComplete || (atrComplete && cflComplete)
                    ? 'initial'
                    : 'none'
              }}
            >
              <QuestionaireForm
                onSubmit={submit}
                surveyData={surveyData}
                customerName={customerName}
                userEmail={decodedToken.user_email}
                submitted={submitted}
                isSubmitting={isSubmitting}
                successful={successful}
                organization={decodedToken.organization}
                title="Attitude to Risk Questionnaire"
                complete={() => setAtrComplete(true)}
                showReviewButtons={!hasCfl}
              />
            </div>
            {hasCfl && riskProfiler && (
              <>
                <div
                  style={{
                    display: atrComplete && !cflSubmitted ? 'initial' : 'none'
                  }}
                >
                  {riskProfiler === 'Morningstar' ? (
                    <ExperienceQuestionnaire
                      form="experience"
                      customer={decodedToken.customer_id}
                      customerName={customerName}
                      portfolio={decodedToken.case_id}
                      complete={() => setCflComplete(true)}
                      onSuccess={() => setCflSubmitted(true)}
                      getResponses={false}
                      showReviewButtons={false}
                      showBlankReportButton={false}
                      getQuestions={() => {
                        return api.getEmailedCustomerExperienceQuestionnaire(
                          props.match.params.token,
                          decodedToken.company_schema
                        );
                      }}
                      submitQuestions={(data: any) => {
                        return api.postEmailedExperienceQuestionnaireResponses(
                          decodedToken.company_schema,
                          props.match.params.token,
                          data
                        );
                      }}
                    />
                  ) : (
                    <CapacityForLossQuestionnaire
                      form="cfl"
                      customer={decodedToken.customer_id}
                      customerName={customerName}
                      portfolio={decodedToken.case_id}
                      complete={() => setCflComplete(true)}
                      onSuccess={() => setCflSubmitted(true)}
                      getResponses={false}
                      showReviewButtons={false}
                      showBlankReportButton={false}
                      getQuestions={() => {
                        return api.getEmailedCustomerCflQuestionnaire(
                          props.match.params.token,
                          decodedToken.company_schema
                        );
                      }}
                      submitQuestions={(data: any) => {
                        return api.postEmailedCFLQuestionnaireReponses(
                          decodedToken.company_schema,
                          props.match.params.token,
                          data
                        );
                      }}
                    />
                  )}
                </div>
                {hasCfl && atrComplete && cflComplete && showSubmit && (
                  <div
                    style={{
                      width: '100%',
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      padding: '12px',
                      background: 'white'
                    }}
                  >
                    <Button
                      color="primary"
                      type="submit"
                      onClick={() => window.location.reload()}
                    >
                      Restart
                    </Button>
                    <RemoteSubmit
                      key="Submit"
                      isLoading={isLoading}
                      formName={['cfl', 'questionaire']}
                      color={'secondary'}
                      nonSubmitFunc={() => {
                        setShowSubmit(false);
                        setCflSubmitted(true);
                      }}
                    >
                      Confirm
                    </RemoteSubmit>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <InfoBanner
            text={
              'Your questionnaire token has been used, please contact your advisor to request another if necessary.'
            }
          />
        )}
      </Loader>
    </>
  );
};

export default compose(
  connect(
    (state: any) => ({
      questions: selectors.questionnareSelectors.getQuestions(state),
      customers: selectors.caseSelectors.caseCustomers(state),
      userResponses: selectors.questionnareSelectors.getUserResponses(state),
      isJointed: selectors.questionnareSelectors.isJoinedCustomers(state),
      riskProfiler: selectors.firmSelectors.riskProfiler(state)
    }),
    {
      setQuestions: actions.questionnareActions.setQuestionnares,
      setAnswers: actions.questionnareActions.setAnswers
    }
  ),
  withMeta
  // withCaseInfo
)(QuestionairePage);
